import React from 'react';

import {translate} from 'iss/strings';
import {SelectableTable} from 'iss/widgets/SelectableTable';
import {Table} from 'iss/widgets/bootstrap/Table';

export function ContractSuppliersList({contractSuppliers, selectable = false, extraColumns = [], ...props}) {
  const TableComponent = selectable ? SelectableTable : Table;
  const columns = defaultColumns;
  return <TableComponent id="contract-suppliers-list" data={contractSuppliers}
    {...props}
    columns={extraColumns.length > 0 ? [...columns, ...extraColumns] : columns}
  />;
}

function insertDecimal(num) {
  if (num % num != 0) { return num; }
  return (num * 100 / 100).toFixed(1);
}

const defaultColumns = [{
      header: translate('contractSuppliers.name'),
      cellProps: (supplier) => ({className: "contract-supplier-name", 'data-supplier-id': supplier.id}),
      accessor: contractSupplier => contractSupplier.name
    }, {
      header: translate('contractSuppliers.serviceInformation'),
      cellProps: {className: "contract-supplier-serviceInformation" },
      accessor: contractSupplier => contractSupplier.serviceInformation
    }, {
      header: translate('contractSuppliers.area'),
      cellProps: {className: "contract-supplier-area" },
      accessor: contractSupplier => contractSupplier.area
    }, {
      header: translate('contractSuppliers.preferredSupplier'),
      cellProps: {className: "contract-supplier-preferredSupplier" },
      accessor: contractSupplier => contractSupplier.preferredSupplier ? translate('contractSuppliers.yes') : ""
    }, {
      header: translate('contractSuppliers.reviewAverage'),
      cellProps: {className: "contract-supplier-reviewAverage" },
      accessor: contractSupplier => insertDecimal(contractSupplier.reviewAverage)
    }, {
      header: translate('contractSuppliers.deleted'),
      cellProps: {className: "contract-supplier-deleted" },
      accessor: contractSupplier => contractSupplier.isActive ? "" : translate('contractSuppliers.yes')
    },
  ];


// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/ContractSuppliersList.jsx